/**
 * Find and redirect another form
 */
class RedirectForm {
    modal;
    status;

    /**
     * Construct
     * @param modal
     */
    constructor(modal) {
        this.modal = modal;
        this.form = modal.activeModal.querySelectorAll('form');
        this.status = this.form.length === 2;
    }

    /**
     * Render action
     */
    render(formData) {
        const form = this.form[1];

        if (form) {
            // Tinkoff
            const email = formData[`${formData.form_name}[email]`];
            const phone = formData[`${formData.form_name}[phone]`];

            let elemEmail = form.querySelector('input[name="customerEmail"]');
            let elemPhone = form.querySelector('input[name="customerPhone"]');

            if (elemEmail && email) {
                elemEmail.value = email;
            }

            if (elemPhone && phone) {
                elemPhone.value = phone;
            }

            // Ya payment form fields
            if (!email) {
                const name = formData[`${formData.form_name}[name]`];
                let elemName = form.querySelector('input[name="custName"]');
                elemPhone = form.querySelector('input[name="cps_phone"]');

                if (elemName && name) {
                    elemName.value = name;
                }

                if (elemPhone && phone) {
                    elemPhone.value = phone;
                    const maskPhone = phone.replace(/[^0-9]+/g, () => {
                        return '';
                    });

                    if (typeof maskPhone !== 'undefined') {
                        let cname = name.split(' ');
                        let elemCustomerNumber = form.querySelector('input[name="customerNumber"]');

                        if (elemCustomerNumber) {
                            if (typeof cname[1] === 'undefined') {
                                cname[1] = '';
                            }

                            elemCustomerNumber.value = `${cname[0]} ${cname[1]}${maskPhone ? ` (${maskPhone})` : ''}`;
                        }
                    }
                }
            }

            form.submit();
        }
    }
}

export default RedirectForm;
